import styled from 'styled-components';
import { ReactElement } from 'react';

import { Translate } from '@dreryk/react-common';
import { DocplannerIcon, Heading, StyledFlex } from '@dreryk/react-components';

import { createAppointmentSourceVisitor } from '~libs.shared.appointments';

import { patientTranslationKeys } from '../../translations';

const StyledUnconfirmedPatientPreviewCard = styled.div`
   padding: 20px;
   background-color: ${(props) => props.theme.backgroundLightest};
   border-radius: 12px;
   flex: 0 0 476px;
   align-self: flex-start;
`;
StyledUnconfirmedPatientPreviewCard.displayName = 'StyledUnconfirmedPatientPreviewCard';

const StyledDocplannerLogo = styled.div`
   width: 24px;
   height: 24px;
   border-radius: 24px;
   padding: 1px;
   background-color: white;
`;
StyledDocplannerLogo.displayName = 'StyledDocplannerLogo';

const StyledUnconfirmedPatientPreviewCardContent = styled.div`
   display: grid;
   grid-template-columns: 177px repeat(2, 1fr);
   grid-auto-rows: 1fr;
   grid-column-gap: 4px;
   grid-row-gap: 24px;
`;
StyledUnconfirmedPatientPreviewCardContent.displayName = 'StyledUnconfirmedPatientPreviewCardContent';

type ComparedPatientPreviewCardProps = {
   readonly children: ReactElement[];
   readonly appointmentSourceLabel: string | undefined;
};

export const ComparedPatientPreviewCard = (props: ComparedPatientPreviewCardProps): JSX.Element => {
   return (
      <StyledUnconfirmedPatientPreviewCard>
         <Heading
            testId={'comparedPatientPreview'}
            type={'h2'}
            content={
               <StyledFlex justifyContent={'space-between'}>
                  <Translate>{patientTranslationKeys.unconfirmed.associatingFileData}</Translate>
                  {props.appointmentSourceLabel
                     ? createAppointmentSourceVisitor(props.appointmentSourceLabel)({
                          visitDocplanner: () => (
                             <StyledDocplannerLogo>
                                <DocplannerIcon />
                             </StyledDocplannerLogo>
                          ),
                          visitEgabinet: () => null,
                          visitPatientPortal: () => null,
                       })
                     : null}
               </StyledFlex>
            }
            bold
         />
         <StyledUnconfirmedPatientPreviewCardContent>{props.children}</StyledUnconfirmedPatientPreviewCardContent>
      </StyledUnconfirmedPatientPreviewCard>
   );
};
